/**
 * Shared constants used for scoring calculations across the application
 */

/**
 * Minimum distance for perfect precision scoring (in game coordinate units)
 * When guess is within this distance from the target, maximum precision bonus is awarded
 */
export const PRECISION_MIN_DISTANCE = 0.3;